import React from 'react';
import { Plus, Trash2 } from 'lucide-react';
import api from '@/lib/api';
import { FREQ_OPTIONS } from '@/components/recovery/recoveryUi';

const inp = 'px-2 py-1.5 rounded-md border border-slate-300 text-[12.5px] outline-none focus:border-teal-600 bg-white';
const blank = { name: '', molecule: '', strength: '', form: 'Tablet', dose: '1', frequency: 'OD', duration_days: 5, food: 'any', sos: false, instructions: '' };

export default function MedicineListEditor({ meds, onChange, testPrefix = 'rec-med' }) {
  const set = (i, patch) => onChange(meds.map((m, j) => (j === i ? { ...m, ...patch } : m)));
  const classify = async (i) => {
    const m = meds[i];
    if (!m.name || m.molecule) return;
    try {
      const { data } = await api.post('/dashboard/medicines/classify', { brand: m.name });
      set(i, { molecule: data.molecule || m.molecule, drug_class: data.drug_class || m.drug_class });
    } catch { /* suggestions are optional (residents) */ }
  };
  return (
    <div className="space-y-2" data-testid={`${testPrefix}-editor`}>
      {meds.map((m, i) => (
        <div key={m.key || i} className="rounded-lg border border-slate-200 bg-slate-50 p-2 grid grid-cols-2 md:grid-cols-6 gap-1.5" data-testid={`${testPrefix}-row-${i}`}>
          <input className={`${inp} col-span-2`} placeholder="Medicine (brand)" value={m.name} onChange={(e) => set(i, { name: e.target.value })} onBlur={() => classify(i)} data-testid={`${testPrefix}-name-${i}`} />
          <input className={inp} placeholder="Molecule" value={m.molecule || ''} onChange={(e) => set(i, { molecule: e.target.value })} />
          <input className={inp} placeholder="Strength" value={m.strength || ''} onChange={(e) => set(i, { strength: e.target.value })} />
          <input className={inp} placeholder="Dose" value={m.dose || ''} onChange={(e) => set(i, { dose: e.target.value })} />
          <select className={inp} value={m.sos ? 'SOS' : m.frequency} onChange={(e) => set(i, { frequency: e.target.value, sos: e.target.value === 'SOS' })} data-testid={`${testPrefix}-freq-${i}`}>
            {FREQ_OPTIONS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
          </select>
          <label className="flex items-center gap-1 text-[12px]">Days
            <input type="number" min={1} max={180} className={`${inp} w-16`} value={m.duration_days} onChange={(e) => set(i, { duration_days: Number(e.target.value) })} data-testid={`${testPrefix}-days-${i}`} />
          </label>
          <select className={inp} value={m.food || 'any'} onChange={(e) => set(i, { food: e.target.value })}>
            <option value="any">Any time</option><option value="before">Before food</option><option value="after">After food</option>
          </select>
          <input className={`${inp} col-span-2 md:col-span-3`} placeholder="Instructions" value={m.instructions || ''} onChange={(e) => set(i, { instructions: e.target.value })} />
          <button type="button" onClick={() => onChange(meds.filter((_, j) => j !== i))} className="text-rose-600 justify-self-end" data-testid={`${testPrefix}-remove-${i}`}><Trash2 size={14} /></button>
        </div>
      ))}
      <button type="button" onClick={() => onChange([...meds, { ...blank }])} className="inline-flex items-center gap-1 text-[12px] font-bold text-teal-700" data-testid={`${testPrefix}-add`}><Plus size={13} /> Add medicine</button>
    </div>
  );
}
